import { computed, ref } from 'vue'

const STORAGE_KEY = 'portal.wishlist'

function load(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}

const wishlist = ref<string[]>(load())

function persist() {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(wishlist.value))
  } catch {
    /* ignore quota errors */
  }
}

/** 컴포넌트 밖(로그아웃 처리 등)에서도 부를 수 있도록 모듈 함수로 둔다. */
export function clearWishlistData() {
  wishlist.value = []
  persist()
}

export function useWishlist() {
  const isWished = (id: string) => wishlist.value.includes(id)

  const toggleWish = (id: string) => {
    wishlist.value = isWished(id)
      ? wishlist.value.filter((item) => item !== id)
      : [id, ...wishlist.value]
    persist()
  }

  const removeWish = (id: string) => {
    if (!isWished(id)) return
    wishlist.value = wishlist.value.filter((item) => item !== id)
    persist()
  }

  const removeMany = (ids: string[]) => {
    if (!ids.length) return
    const drop = new Set(ids)
    wishlist.value = wishlist.value.filter((item) => !drop.has(item))
    persist()
  }

  const addMany = (ids: string[]) => {
    if (!ids.length) return
    const merged = [...ids.filter((id) => id && !wishlist.value.includes(id)), ...wishlist.value]
    wishlist.value = merged
    persist()
  }

  const wishCount = computed(() => wishlist.value.length)

  return {
    wishlist,
    wishCount,
    isWished,
    toggleWish,
    removeWish,
    removeMany,
    addMany,
    clearWishlist: clearWishlistData,
  }
}
